import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { TOUR_PENDING_KEY, resumeQrStage, resumeTimezoneStage } from '../Shared/WhatsNew/tours';
import { resumeOnboardingSettings } from '../Shared/WhatsNew/onboardingTour';

// Dependencies
import { CompanyLogoContext } from '../../Context/CompanyLogoContextProvider';
import {
  uploadLogo as uploadLogoAction,
  setLogoLink,
  // All 15 config toggles below are now loaded in one batched call
  // (getSettingsPageConfig); only their setters remain imported here.
  setManufacturerSwitchPosition,
  setRoomCalcSwitchPosition,
  setLocationSwitchPosition,
  setCustomerCreateAccountsSwitchPos,
  setProdCheckoutSwitchPosition,
  setProdFavSwitchPosition,
  getMaterialClassCodes,
  getCodeTranslations,
  getUom,
  getQrPrintConfig,
  setNotificationsSwitchPos,
  getNotificationsSwitchPos,
  setRoomvoToggle,
  updateLocation,
  getSampleReminderConfig,
  setSampleReminderConfig,
  getCatalogCsv,
  setQconnectConfig,
  getQconnectConfig,
  setShowCollectionToCustomer,
  setShouldRequireOptionSelection,
  setCombineStyleSizesSelection,
  setShowSpecsToCustomer,
  setShouldRequireLoginSelection,
  setShowProductDiscoverySelection,
  setShowRelatedProductsSelection,
  getSettingsPageConfig,
} from '../../Actions';
import { AlertContext } from '../../Context/AlertContextProvider';
import MaterialClassSettings from './MaterialClassSetting';
import UomSettings from './UomSettings';
import QrPrintSetting from './QrPrintSettings';
import QrStylePresets from './QrStylePresets';
import BarcodeSettings from './BarcodeSettings';

// MUI
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import ToolTip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  CircularProgress,
  Backdrop,
} from '@material-ui/core';

// Styles
import '../styles/Admin.css';
import { AdminContext } from '../../Context/AdminContextProvider';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { AppContext } from '../../Context/AppContextProvide';
import { useTimezone } from '../../Context/TimezoneContextProvider';
import TimezonePicker from '../Shared/TimezonePicker';
import { zoneLabel } from '../../Util/timezone';

const LogoLinkUpdate = () => {
  const history = useHistory();
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);
  const { locations, setUpdate: updateAdminContext } = useContext(AdminContext);
  const { user } = useContext(AppContext);

  const { logoLink, setUpdate: setLogoUpdate, companyLogo } = useContext(CompanyLogoContext);
  const { defaultZone, saveDefaultTimezone } = useTimezone();
  const [instanceTimezone, setInstanceTimezone] = useState('');
  const [savingInstanceTz, setSavingInstanceTz] = useState(false);
  const [companyLink, setCompanyLink] = useState('www.yoursite.com');
  const [file, setFile] = useState();
  const hiddenFileInput = useRef(null);
  const [switchState, setSwitchState] = useState(false);
  const [roomvoSwitchState, setRoomvoSwitchState] = useState(false);
  const [roomCalcSwitchState, setRoomCalcSwitchState] = useState(false);
  const [locationSwitchState, setLocationSwitchState] = useState(false);
  const [userRegSwitchState, setUserRegSwitchState] = useState(false);
  const [notificationsSwitchState, setNotificationsSwitchState] =
    useState(false);
  const [prodCheckoutSwitchState, setProdCheckoutSwitchState] = useState(false);
  const [prodFavSwitchState, setProdFavSwitchState] = useState(false);
  const [prodCollectionSwitchState, setProdCollectionSwitchState] = useState(false);
  const [prodDiscoverySwitchState, setProdDiscoverySwitchState] = useState(false);
  const [prodRelatedSwitchState, setProdRelatedSwitchState] = useState(false);
  const [prodSpecsSwitchState, setProdSpecsSwitchState] = useState(false);
  const [prodReqSelSwitchState, setProdReqSelSwitchState] = useState(false);
  const [prodReqLoginSwitchState, setProdReqLoginSwitchState] = useState(false);
  const [prodCombineStyleSizesSwitchState, setProdCombineStyleSizesSwitchState] = useState(false);
  const [open, setOpen] = useState(false);
  const [matClassCdArray, setMatClassCdArray] = useState([]);
  const [codeTranslationArray, setCodeTranslationArray] = useState([]);
  const [uomArray, setUomArray] = useState([]);
  const [dialogSelect, setDialogSelect] = useState('');
  const [margins, setMargins] = useState([]);
  const [isSampleReminderDialogOpen, setIsSampleReminderDialogOpen] =
    useState(false);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [tempLocationName, setTempLocationName] = useState('');
  const [tempLocationEmail, setTempLocationEmail] = useState('');
  const [tempLocationPhone, setTempLocationPhone] = useState('');
  const [notificationSectionToggle, setNotificationSectionToggle] = useState('config');
  const [checkoutPeriod, setCheckoutPeriod] = useState('');
  const [pastDueLimit, setPastDueLimit] = useState('');
  const [pastDueFrequency, setPastDueFrequency] = useState('');
  const [dailyStart, setDailyStart] = useState('');
  const [dailyEnd, setDailyEnd] = useState('');
  const [refreshData, setRefreshData] = useState(true);
  const [qconnectToggle, setQconnectToggle] = useState(false);
  const [qconnectUser, setQconnectUser] = useState("");
  const [qconnectPass, setQconnectPass] = useState("");
  const [isCatalogProcessing, setIsCatalogProcessing] = useState(false);
  const [isSettingsDataLoading, setIsSettingsDataLoading] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem(TOUR_PENDING_KEY) === 'qr') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => resumeQrStage(history), 500);
    } else if (sessionStorage.getItem(TOUR_PENDING_KEY) === 'timezone') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => resumeTimezoneStage(history), 500);
    } else if (sessionStorage.getItem(TOUR_PENDING_KEY) === 'onboarding-settings') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => resumeOnboardingSettings(history), 500);
    }
  }, []);

  useEffect(() => {
    if (selectedLocation) {
      const location = locations.find(l => l.location_id === selectedLocation);
      setTempLocationEmail(location?.location_email ?? '');
      setTempLocationPhone(location?.location_phone ?? '');
      setTempLocationName(location?.customer_facing_name ?? '');
    }
  }, [selectedLocation])

  useEffect(() => {
    async function getPageData() {
      const isOn = (v) => Number(v) === 1;

      // All 15 config toggles in one batched call instead of 15 sequential GETs.
      // Returns { configs: { KEY: { app_value, app_value_text } } }; some toggles
      // live in app_value, the "active"-style ones in app_value_text.
      const configPromise = getSettingsPageConfig()
        .then((result) => {
          const configs = result.data.configs ?? {};
          const val = (key) => configs[key]?.app_value;
          const text = (key) => configs[key]?.app_value_text;

          setProdCheckoutSwitchState(isOn(val('PRODUCT_CHECKOUT')));
          setProdFavSwitchState(isOn(val('PRODUCT_FAVORITE')));
          setUserRegSwitchState(isOn(val('CUSTOMER_CREATE_ACCOUNT')));
          setSwitchState(isOn(text('SHOW_MANUFACTURER_TO_CUSTOMER')));
          setRoomCalcSwitchState(isOn(text('SHOW_ROOM_CALCULATOR')));
          setLocationSwitchState(isOn(text('SHOW_LOCATION_TO_CUSTOMER')));
          setRoomvoSwitchState(isOn(val('ROOMVO_TOGGLE')));
          setProdReqLoginSwitchState(isOn(val('REQUIRE_LOGIN_FOR_PRICING')));
          setProdSpecsSwitchState(isOn(val('SHOW_SPECS_TO_CUSTOMER')));
          setProdCollectionSwitchState(isOn(val('SHOW_COLLECTION_TO_CUSTOMER')));
          setProdReqSelSwitchState(isOn(val('REQUIRE_OPTION_SELECTION')));
          setProdCombineStyleSizesSwitchState(isOn(val('COMBINE_STYLE_SIZES')));
          setProdDiscoverySwitchState(isOn(val('SHOW_PRODUCT_DISCOVERY')));
          setProdRelatedSwitchState(isOn(val('SHOW_RELATED_PRODUCTS')));

          const qconnectOn = isOn(val('QCONNECT_TOGGLE'));
          setQconnectToggle(qconnectOn);

          // Credentials are a separate (sensitive) call — only fetch when enabled.
          if (qconnectOn) {
            return getQconnectConfig()
              .then((qResult) => {
                const { username, password } = qResult.data;
                setQconnectUser(username ?? "");
                setQconnectPass(password ?? "");
              })
              .catch(() => {});
          }
        })
        .catch(() => {
          setProdCheckoutSwitchState(false);
          setProdFavSwitchState(false);
          setUserRegSwitchState(false);
          setSwitchState(false);
          setRoomCalcSwitchState(false);
          setLocationSwitchState(false);
          setRoomvoSwitchState(false);
          setProdReqLoginSwitchState(false);
          setProdSpecsSwitchState(false);
          setProdCollectionSwitchState(false);
          setProdReqSelSwitchState(false);
          setProdCombineStyleSizesSwitchState(false);
          setProdDiscoverySwitchState(false);
          setProdRelatedSwitchState(false);
          setQconnectToggle(false);
        });

      // These hit different tables/shapes so they stay separate — but run the whole
      // set concurrently instead of awaiting one at a time (was ~22 serial trips).
      await Promise.all([
        configPromise,
        getQrPrintConfig()
          .then((result) => setMargins(result.data.data[0].config ?? []))
          .catch(() => setMargins([])),
        getUom()
          .then((result) => setUomArray(result.data.data ?? []))
          .catch(() => setUomArray([])),
        getCodeTranslations()
          .then((result) => setCodeTranslationArray(result.data.data ?? []))
          .catch(() => setCodeTranslationArray([])),
        getMaterialClassCodes()
          .then((result) => setMatClassCdArray(result.data.data ?? []))
          .catch(() => setMatClassCdArray([])),
        getNotificationsSwitchPos()
          .then((result) => setNotificationsSwitchState(Number(result.data.sample_reminder) === 1))
          .catch(() => setNotificationsSwitchState(false)),
        getSampleReminderConfig()
          .then((result) => {
            setCheckoutPeriod(Math.floor(result.data.checkoutPeriod) ?? '');
            setPastDueLimit(Math.floor(result.data.pastDueLimit) ?? '');
            setPastDueFrequency(Math.floor(result.data.pastDueFrequency) ?? '');
            setDailyStart(Math.floor(result.data.dailyStart) ?? '');
            setDailyEnd(Math.floor(result.data.dailyEnd) ?? '');
          })
          .catch(() => {
            setCheckoutPeriod('');
            setPastDueLimit('');
            setPastDueFrequency('');
            setDailyStart('');
            setDailyEnd('');
          }),
      ]);

      if (isSettingsDataLoading) {
        setIsSettingsDataLoading(false);
      }
    }

    if (logoLink.length) {
      setCompanyLink(logoLink);
    }

    if (refreshData) {
      getPageData();
      setRefreshData(false);
    }
  }, [refreshData]);

  useEffect(() => {
    if (logoLink.length) {
        setCompanyLink(logoLink);
    }
  }, [logoLink]);

  useEffect(() => {
    if (defaultZone) setInstanceTimezone(defaultZone);
  }, [defaultZone]);

  const handleInstanceTimezoneSave = async () => {
    if (!instanceTimezone) return;
    setSavingInstanceTz(true);
    try {
      await saveDefaultTimezone(instanceTimezone);
      setMessage('Default timezone updated');
      setMessageType('success');
      handleAlertOpen();
    } catch (err) {
      setMessage('Error updating default timezone');
      setMessageType('error');
      handleAlertOpen();
    }
    setSavingInstanceTz(false);
  };


  const handleUpdateLogoLink = (e) => {
    setCompanyLink(e.target.value);
  };

  const handleLogoLinkUpdate = () => {
    setLogoLink(companyLink)
      .then(() => {
        setMessage('Successfully updated logo link');
        setMessageType('success');
        handleAlertOpen();
        window.location.reload();
      })
      .catch(() => {
        setMessage('Error updating logo link');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  const handleFileUpload = (event) => {
    let pickedFile;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setFile(pickedFile);
    }
  };

  const handleUpload = () => {
    hiddenFileInput.current.click();
  };

  const uploadLogo = () => {
    let formData = new FormData();
    formData.append('image', file);
    uploadLogoAction(formData)
      .then((result) => {
        setMessage('Logo Uploaded Successfully');
        setMessageType('success');
        handleAlertOpen();
        setLogoUpdate(true);
        window.location.reload();
      })
      .catch((err) => {
        setMessage('Failed to upload company logo');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  // const handleCancel = () => {
  //   window.location.reload()
  // };

  const handleManufacturerToggle = async (value) => {
    if (!value) return;
    
    setSwitchState(value === 'on' ? 1 : 0);
    await setManufacturerSwitchPosition(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleRoomvoChange = async (value) => {
    if (!value) return;
    
    setRoomvoSwitchState(value === 'on' ? 1 : 0);
    await setRoomvoToggle(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleRoomCalcChange = async (value) => {
    if (!value) return;
    
    setRoomCalcSwitchState(value === 'on' ? 1 : 0);
    await setRoomCalcSwitchPosition(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleLocationChange = async (value) => {
    if (!value) return;
    
    setLocationSwitchState(value === 'on' ? 1 : 0);
    await setLocationSwitchPosition(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdCheckoutChange = async (value) => {
    if (!value) return;
    
    setProdCheckoutSwitchState(value === 'on' ? 1 : 0);
    await setProdCheckoutSwitchPosition(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdFavChange = async (value) => {
    if (!value) return;
    
    setProdFavSwitchState(value === 'on' ? 1 : 0);
    await setProdFavSwitchPosition(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdCollectionChange = async (value) => {
    if (!value) return;
    
    setProdCollectionSwitchState(value === 'on' ? 1 : 0);
    await setShowCollectionToCustomer(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdSpecsChange = async (value) => {
    if (!value) return;
    
    setProdSpecsSwitchState(value === 'on' ? 1 : 0);
    await setShowSpecsToCustomer(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdReqSelChange = async (value) => {
    if (!value) return;
    
    setProdReqSelSwitchState(value === 'on' ? 1 : 0);
    await setShouldRequireOptionSelection(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdReqLoginChange = async (value) => {
    if (!value) return;
    
    setProdReqLoginSwitchState(value === 'on' ? 1 : 0);
    await setShouldRequireLoginSelection(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };



  const handleProdCombineStyleSizesChange = async (value) => {
    if (!value) return;
    
    setProdCombineStyleSizesSwitchState(value === 'on' ? 1 : 0);
    await setCombineStyleSizesSelection(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleUserRegChange = async (value) => {
    if (!value) return;
    
    setUserRegSwitchState(value === 'on' ? 1 : 0);
    await setCustomerCreateAccountsSwitchPos(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleNotificationsChange = async (value) => {
    if (!value) return;
    
    setNotificationsSwitchState(value === 'on' ? 1 : 0);
    await setNotificationsSwitchPos(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdDiscoveryChange = async (value) => {
    if (!value) return;
    
    setProdDiscoverySwitchState(value === 'on' ? 1 : 0);
    await setShowProductDiscoverySelection(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const handleProdRelatedChange = async (value) => {
    if (!value) return;
    
    setProdRelatedSwitchState(value === 'on' ? 1 : 0);
    await setShowRelatedProductsSelection(value === 'on' ? '1' : '0');
    setRefreshData(true);
  };

  const renderImg = () => {
    return file === undefined ? (
      <img className="company-logo" src={companyLogo} alt="LOGO"></img>
    ) : (
      <img
        className="company-logo"
        src={file ? URL.createObjectURL(file) : null}
        alt={file ? file.name : null}
      />
    );
  };

  const renderUploadLogo = () => {
    return (
      <div>
        <div className="mnd__header">
          <Typography className="header-text" variant="h4">
            Company Logo
          </Typography>
        </div>
        <div style={{ width: '90%', margin: 'auto', display: 'flex', alignItems: 'center', gap: 16 }}>
          <input
            className="admin__bulletin-image-uploader"
            type="file"
            ref={hiddenFileInput}
            onChange={handleFileUpload}
            accept="image/x-png"
          ></input>
          <div>
            <h4 className="upload-logo-text">Image Preview:</h4>
            {renderImg()}
          </div>
          <Button
            className="admin__search-logo-btn"
            variant="contained"
            onClick={handleUpload}
          >
            Browse Image
          </Button>
          <Button
            className="admin__upload-logo-btn"
            variant="contained"
            onClick={uploadLogo}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  };

  const renderLogoLink = () => {
    return (
      <div>
        <div className="mnd__header">
          <Typography className="header-text" variant="h4">
            Logo Link
          </Typography>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '90%', margin: 'auto' }}>
          <TextField
            variant="filled"
            name="logolink"
            label="Eg. http://www.yoursite.com"
            placeholder="Enter Company Link"
            value={companyLink}
            onChange={handleUpdateLogoLink}
            style={{ flex: 1 }}
          />
          <Button
            className="admin__logo-link-btn"
            variant="contained"
            onClick={handleLogoLinkUpdate}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMaterialClassOpen = () => {
    setDialogSelect('materialClass');
    setOpen(true);
  };

  const handleUomOpen = () => {
    setDialogSelect('uom');
    setOpen(true);
  };

  const handleQrMarginOpen = () => {
    setDialogSelect('qr code margins');
    setOpen(true);
  };

  const handleQrStyleOpen = () => {
    setDialogSelect('qr styles');
    setOpen(true);
  };

  const submitLocationChanges = async () => {
    if (!selectedLocation) {
      setMessage('Failed to update location. No location selected');
      setMessageType('error');
      handleAlertOpen();

      return;
    }

    const location = locations?.find(l => l.location_id === selectedLocation);

    if (!location) {
      setMessage('Failed to update location. Location not found');
      setMessageType('error');
      handleAlertOpen();

      return;
    }

    updateLocation(
      location?.location_id,
      location?.location_name,
      location?.location_description,
      location?.sample_reminder,
      tempLocationName ? tempLocationName : null,
      tempLocationPhone ? tempLocationPhone : null,
      tempLocationEmail ? tempLocationEmail : null
    )
      .then((result) => {
        setMessage('Successfully updated location');
        setMessageType('success');
        handleAlertOpen();
        updateAdminContext(true);
        setRefreshData(true);
      })
      .catch((err) => {
        setMessage('Failed to update location');
        setMessageType('error');
        handleAlertOpen();
      });
  }

  const submitNotificationConfigChanges = async () => {
    if (!checkoutPeriod || !pastDueLimit || !pastDueFrequency || !dailyStart || !dailyEnd) {
      setMessage('Failed to update notification config. One of the settings is invalid');
      setMessageType('error');
      handleAlertOpen();

      return;
    }

    if (parseInt(dailyStart) >= parseInt(dailyEnd)) {
      setMessage('Failed to update notification config. the daily start needs to be less than the daily end');
      setMessageType('error');
      handleAlertOpen();

      return;
    }

    setSampleReminderConfig(checkoutPeriod, pastDueLimit, pastDueFrequency, dailyStart, dailyEnd)
      .then(result => {
        setMessage('Successfully updated the notification config!');
        setMessageType('success');
        handleAlertOpen();
        setRefreshData(true);
      })
      .catch(e => {
        setMessage('Failed to update notification config');
        setMessageType('error');
        handleAlertOpen();

        return;
      })
  }

  const getQConnectData = async () => {
    setIsCatalogProcessing(true);

    await getCatalogCsv()
      .then((result) => {
        setMessage("Qfloors catalog processed");
        setMessageType("success");
        handleAlertOpen();
      }).catch((err) => {
        setMessage("Error processing Qfloors catalog");
        setMessageType("error");
        handleAlertOpen();
      });

    setIsCatalogProcessing(false);
  }

  const updateCredentials = async () => {
    await setQconnectConfig({ username: qconnectUser, password: qconnectPass })
      .then((result) => {
        setMessage("Updated QConnect credentials");
        setMessageType("success");
        handleAlertOpen();
      }).catch((err) => {
        setMessage("Error updating QConnect credentials");
        setMessageType("error");
        handleAlertOpen();
      });
  }

  const renderDialog = () => {
    return (
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth="lg"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <DialogTitle className="files-by-partner-header">
          {dialogSelect === 'materialClass'
            ? 'Material Class Codes'
            : dialogSelect === 'uom'
              ? 'Units of Measure'
              : dialogSelect === 'qr styles'
                ? 'QR Code Styles'
                : 'QR Print Margins'}
          <Button
            variant="outlined"
            style={{
              color: '#FF682C',
              marginLeft: 20,
              fontSize: 20,
              float: 'right',
              border: '1px solid #DCDCDC',
            }}
            onClick={handleClose}
          >
            X
          </Button>
        </DialogTitle>
        {dialogSelect === 'materialClass' ? (
          <MaterialClassSettings
            matClassCdArray={matClassCdArray}
            codeTranslationArray={codeTranslationArray}
          />
        ) : dialogSelect === 'uom' ? (
          <UomSettings
            uomArray={uomArray}
            codeTranslationArray={codeTranslationArray}
          />
        ) : dialogSelect === 'qr styles' ? (
          <QrStylePresets />
        ) : (
          <QrPrintSetting margins={margins} />
        )}
      </Dialog>
    );
  };

  if (isSettingsDataLoading) {
    return (
      <Backdrop open={true}>
        <CircularProgress size={100} style={{color: "#FFFFFF"}}/>
      </Backdrop>
    )
  }

  return (
    <div className="settings__container">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item" style={{ display: 'flex' }}>
          <Paper id="tour-qr-settings" elevation={5} style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" className="header-text">
              QR Print Settings
            </Typography>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, padding: '0 16px' }}>
                <Button size="small" variant="contained" onClick={handleQrMarginOpen}>
                  Edit Print Margins
                </Button>
                <Button id="tour-qr-styles-btn" size="small" variant="contained" onClick={handleQrStyleOpen}>
                  Edit QR Styles
                </Button>
              </div>
            </div>
            <Accordion style={{ marginTop: 'auto' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="qr-print-content"
              >
                <Typography variant="h5">QR Print Settings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Configure your QR code price labels. Edit Print Margins to adjust label positioning on the sheet. Edit QR Styles to create and manage named style presets — colors, dot patterns, logo, label text, and price-based colors — that users can choose between when printing.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item" style={{ display: 'flex' }}>
          <Paper elevation={5} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" className="header-text">
              New User Registration
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, margin: '20px 16px' }}>
              <ToggleButtonGroup
                value={userRegSwitchState ? 'on' : 'off'}
                exclusive
                size='small'
                onChange={(e, newValue) => handleUserRegChange(newValue)}
                aria-label="text alignment"
              >
                <ToggleButton value='on' aria-label="allow new user registration" style={userRegSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                  Yes
                </ToggleButton>
                <ToggleButton value='off' aria-label="deny new user registration" style={!userRegSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                  No
                </ToggleButton>
              </ToggleButtonGroup>
              <Typography variant="body1">
                Allow New User Registration?
              </Typography>
            </div>
            <Accordion style={{ marginTop: 'auto' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">New User Registration</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Use this switch to allow customers to create an account.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} className="admin__grid-item">
          <Paper elevation={5}>
            <Typography
                variant="h4"
                className="header-text"
              >
                User Notification Settings
            </Typography>
            <Grid container spacing={1} style={{textAlign: "center"}}>
              <Grid item xs={12} sm={12} md={6} lg={5} style={{textAlign: "left", margin: "10px auto", padding: "0px 20px"}}>
                <Typography variant="h4" className="admin__product-settings" style={{textAlign: "center"}}>
                  Sample Reminders
                </Typography>
                <Grid container spacing={2} style={{margin: "15px 10px"}}>
                  <Grid item xs={12} style={{textAlign: "center"}}>
                    <ToggleButtonGroup
                      value={notificationsSwitchState ? 'on' : 'off'}
                      exclusive
                      size='small'
                      onChange={(e, newValue) => handleNotificationsChange(newValue)}
                      aria-label="text alignment"
                      style={{display: "inline-block"}}
                    >
                      <ToggleButton value='on' aria-label="send sample reminders" style={notificationsSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                        Yes
                      </ToggleButton>
                      <ToggleButton value='off' aria-label="dont send sample reminders" style={!notificationsSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                        No
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                      Allow Sample Checkout Reminders?
                    </Typography>
                  </Grid>
                </Grid>
                <div style={{textAlign: "center", marginTop: "40px"}}>
                  <ToggleButtonGroup
                    value={notificationSectionToggle}
                    exclusive
                    onChange={(e, alignment) => {
                      if (!alignment) return;

                      setNotificationSectionToggle(alignment)
                    }}
                    aria-label="text alignment"
                  >
                    <ToggleButton value="config" aria-label="left aligned">
                      Notification Config
                    </ToggleButton>
                    <ToggleButton value="locations" aria-label="right aligned">
                      Location Info
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
                { notificationSectionToggle === 'locations' ? (
                    <div className="admin__product-settings" style={{marginTop: "20px"}}>
                      <FormControl style={{width: "60%", minWidth: "250px", margin: "auto", textAlign: "left"}}>
                        <InputLabel id="locations-label">Locations</InputLabel>
                        <Select
                          labelId="locations-label"
                          id="locations"
                          value={selectedLocation}
                          variant="filled"
                          onChange={(e) => setSelectedLocation(e.target.value)}
                        >
                          <MenuItem value="">Please select a location</MenuItem>
                          {locations?.map((l) => {
                            return (
                              <MenuItem key={l.location_id} value={l.location_id}>
                                {l.location_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>

                      { selectedLocation ? (
                          <div style={{width: "60%", minWidth: "250px", margin: "auto"}}>
                            <h3 style={{textAlign: "left"}}>Contact Info</h3>
                            <TextField
                              label="Name"
                              variant="filled"
                              fullWidth
                              style={{margin: "0px auto 5px", textAlign: "left"}}
                              value={tempLocationName}
                              onChange={(e) => setTempLocationName(e.target.value)}
                            />

                            <TextField
                              label="Email"
                              variant="filled"
                              fullWidth
                              style={{margin: "5px auto", textAlign: "left"}}
                              value={tempLocationEmail}
                              onChange={(e) => setTempLocationEmail(e.target.value)}
                            />

                            <TextField
                              label="Phone"
                              variant="filled"
                              fullWidth
                              style={{margin: "5px auto", textAlign: "left"}}
                              value={tempLocationPhone}
                              onChange={(e) => setTempLocationPhone(e.target.value)}
                            />
                            <Button
                              variant='contained'
                              className="admin__upload-logo-btn"
                              onClick={() => submitLocationChanges()}
                              style={{float: "right"}}
                            >
                              Update Location
                            </Button>
                          </div>
                        ) : undefined
                      }
                    </div>
                  ) : (
                    <div style={{width: "60%", minWidth: "250px", margin: "20px auto auto"}}>
                      <TextField
                        label="Checkout Period (Days)"
                        variant="filled"
                        fullWidth
                        type="number"
                        inputProps={{min: 1}}
                        style={{margin: "0px auto 5px", textAlign: "left"}}
                        value={checkoutPeriod}
                        onChange={(e) => setCheckoutPeriod(e.target.value)}
                      />

                      <TextField
                        label="Past Due Limit (Days)"
                        variant="filled"
                        fullWidth
                        type="number"
                        inputProps={{min: 1}}
                        style={{margin: "5px auto", textAlign: "left"}}
                        value={pastDueLimit}
                        onChange={(e) => setPastDueLimit(e.target.value)}
                      />

                      <TextField
                        label="Past Due Notification Frequency (Days)"
                        variant="filled"
                        fullWidth
                        type="number"
                        inputProps={{min: 1}}
                        style={{margin: "5px auto", textAlign: "left"}}
                        value={pastDueFrequency}
                        onChange={(e) => setPastDueFrequency(e.target.value)}
                      />

                      <TextField
                        label="Daily Time Range Start Hour (CST)"
                        variant="filled"
                        fullWidth
                        type="number"
                        inputProps={{min: 0, max: 23}}
                        style={{margin: "5px auto", textAlign: "left"}}
                        value={dailyStart}
                        onChange={(e) => setDailyStart(e.target.value)}
                      />

                      <TextField
                        label="Daily Time Range End Hour (CST)"
                        variant="filled"
                        fullWidth
                        type="number"
                        inputProps={{min: 1, max: 24}}
                        style={{margin: "5px auto", textAlign: "left"}}
                        value={dailyEnd}
                        onChange={(e) => setDailyEnd(e.target.value)}
                      />

                      <Button
                        variant='contained'
                        className="admin__upload-logo-btn"
                        onClick={() => submitNotificationConfigChanges()}
                        style={{float: "right"}}
                      >
                        Update Config
                      </Button>
                    </div>
                  )
                }
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: "left", margin: "10px auto", padding: "0px 20px"}}>
                <Typography variant="h4" className="admin__product-settings" style={{textAlign: "left"}}>
                  Instructions
                </Typography>
                <List style={{padding: "0px"}}>
                  <ListItem>
                    <ListItemText>Please click on Location Info and use the dropdown to ensure that the contact info for each location has been filled out. Notifications will not be sent out unless this information is present.</ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Notifications can be toggled on or off on the site (this toggle), location, role, and user levels. In order to change the other levels you will need to edit them on the <a href="/admin">Admin page</a>.</ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Sample reminders will send a notification through email or text based on the selection set by the customer when creating their profile or by the salesperson during guest checkout.</ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Reminders will be sent out during the daily time range period the day before samples are due, the day of, and every day after until the past due limit is reached</ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>The checkout period, past due limit, and the daily time range to send reminders can all be changed by clicking on Notification Config and submitting new values</ListItemText>
                  </ListItem>
                </List>
                <Button
                  variant="contained"
                  style={{margin: "10px 0px 0px"}}
                  onClick={() => setIsSampleReminderDialogOpen(true)}
                >
                  View Reminder Examples
                </Button>
              </Grid>
            </Grid>
            <Accordion style={{marginTop: "20px"}}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">User Notification Settings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Use this switch to allow users to receive notifications. Currently this only sends out reminder notifications for checked out samples
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Dialog open={isSampleReminderDialogOpen} onClose={() => setIsSampleReminderDialogOpen(false)}>
              <Paper>
                <Typography
                  className="header-text"
                  variant="h4"
                >
                  <b>Example Reminders</b>
                </Typography>
                <div style={{padding: "20px"}}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography variant="h5" style={{marginBottom: "20px"}}><b>Email</b></Typography>
                      <Typography style={{marginBottom: "10px"}}>{"{{ First Name }}"},</Typography>
                      <Typography style={{marginBottom: "10px"}}>This is a friendly reminder you checked out the following flooring samples from {"{{ Location Name }}"}. These samples are due back to our store today or next business day.</Typography>
                      <List style={{padding: "0px", marginBottom: "10px"}}>
                        <ListItem style={{padding: "0px 20px"}}>
                          <ListItemText>- {"{{ Sample 1 Name }}"}</ListItemText>
                        </ListItem>
                        <ListItem style={{padding: "0px 20px"}}>
                          <ListItemText>- {"{{ Sample 2 Name }}"}</ListItemText>
                        </ListItem>
                      </List>
                      <Typography style={{marginBottom: "10px"}}>If you have any questions please contact the store at {"{{ Location Number }}"}.</Typography>
                      <Typography>Thank you,</Typography>
                      <Typography>{"{{ Location Name }}"}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5" style={{marginBottom: "20px"}}><b>Text Message</b></Typography>
                      <Typography>{"{{ First Name }}"}, this is a reminder that the 3 samples you checked out from {"{{ Location Name }}"} are due back to our store today or next business day. For questions please call the store at {"{{ Location Number }}"}.</Typography>
                    </Grid>
                    <Grid item xs={12} style={{marginTop: "20px", textAlign: "right"}}>
                      <Button
                        variant="contained"
                        onClick={() => setIsSampleReminderDialogOpen(false)}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            </Dialog>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} className="admin__grid-item">
          <Paper elevation={5}>
            <Typography variant="h4" className="header-text">
              Roomvo Settings
            </Typography>
            <Grid container spacing={1} style={{ textAlign: 'center' }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={5}
                style={{
                  textAlign: 'left',
                  margin: '10px auto',
                  padding: '0px 20px',
                }}
              >
                <Typography
                  variant="h4"
                  className="admin__product-settings"
                  style={{ textAlign: 'center' }}
                >
                  Roomvo Visualizer
                </Typography>
                <Grid container spacing={2} style={{margin: "15px 10px"}}>
                  <Grid item xs={12} style={{textAlign: "center"}}>
                    <ToggleButtonGroup
                      value={roomvoSwitchState ? 'on' : 'off'}
                      exclusive
                      size='small'
                      onChange={(e, newValue) => handleRoomvoChange(newValue)}
                      aria-label="text alignment"
                      style={{display: "inline-block"}}
                    >
                      <ToggleButton value='on' aria-label="show roomvo button" style={roomvoSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                        Yes
                      </ToggleButton>
                      <ToggleButton value='off' aria-label="hide roomvo button" style={!roomvoSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                        No
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                      Show Roomvo Button On Product Page?
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{
                  textAlign: 'left',
                  margin: '10px auto',
                  padding: '0px 20px',
                }}
              >
                <Typography
                  variant="h4"
                  className="admin__product-settings"
                  style={{ textAlign: 'left' }}
                >
                  Roomvo Instructions
                </Typography>
                <Typography style={{ margin: '10px 0px 0px' }}>
                  <b>Already a Roomvo Customer?</b>
                </Typography>
                <List style={{ padding: '0px' }}>
                  <ListItem>
                    <ListItemText>
                      Please contact our support team and let them know you
                      already utilize Roomvo. There are extra steps that we need
                      to follow on the backend to ensure the integration works
                      correctly.
                    </ListItemText>
                  </ListItem>
                </List>
                <Typography style={{ margin: '10px 0px 0px' }}>
                  <b>New to Roomvo?</b>
                </Typography>
                <List style={{ padding: '0px' }}>
                  <ListItem>
                    <ListItemText>
                      1. If you have not signed up with roomvo already, please
                      go to the{' '}
                      <a
                        href="https://www.roomvo.com/share/ShowroomPricing"
                        target="_blank"
                      >
                        signup page
                      </a>
                      .
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      2. Make sure your Showroom Pricing URL is added to your
                      Roomvo account.
                    </ListItemText>
                  </ListItem>
                </List>
                <Typography>
                  <b>
                    Please note: Roomvo links will be on all product pages and
                    is based on the product SKU. If a SKU is not in Roomvo's
                    system then a random product will be shown instead.{' '}
                    <u>
                      This is a limitation with Roomvo and not Showroom Pricing.
                    </u>
                  </b>
                </Typography>
              </Grid>
            </Grid>
            <Accordion style={{ marginTop: '20px' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Roomvo Settings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Here you can toggle your Roomvo integration to decide if it
                  should show on the product pages or not.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        { qconnectToggle ? (
            <Grid item xs={12} sm={12} md={12} lg={12} className="admin__grid-item">
              <Paper elevation={5}>
                <Typography
                    variant="h4"
                    className="header-text"
                  >
                    QConnect Settings
                </Typography>
                <Grid container spacing={1} style={{textAlign: "center"}}>
                  <Grid item xs={12} sm={12} md={6} lg={5} style={{textAlign: "left", margin: "10px auto", padding: "0px 20px"}}>
                    <Typography variant="h4" className="admin__product-settings" style={{textAlign: "left"}}>
                      QConnect Credentials
                    </Typography>
                    <div style={{margin: "10px 0px 0px", maxWidth: "300px"}}>
                      <TextField
                        label={"Username"}
                        placeholder={"Username"}
                        type={"text"}
                        variant="filled"
                        value={qconnectUser}
                        required={true}
                        style={{width: "100%", margin: "10px auto"}}
                        onChange={(e) => setQconnectUser(e.target.value)}
                      />
                      <TextField
                        label={"Password"}
                        placeholder={"Password"}
                        type={"password"}
                        variant="filled"
                        value={qconnectPass}
                        required={true}
                        style={{width: "100%", margin: "10px auto"}}
                        onChange={(e) => setQconnectPass(e.target.value)}
                      />
                    </div>
                    <Button variant="contained" onClick={() => updateCredentials()} style={{display: "inline-block", margin: "30px 20px 20px 0px"}}>
                      Update Credentials
                    </Button>
                    <Button variant="contained" onClick={() => getQConnectData()} style={{display: "inline-block", backgroundColor: "#4caf50", color: "#FFFFFF", margin: "30px 20px 20px 0px"}}>
                      { isCatalogProcessing ? (
                          <><CircularProgress size={18} style={{color: "#FFFFFF", display: "inline-block", verticalAlign: "text-top", marginRight: "5px"}}/> Processing...</>
                        ) : 'Process Catalog'
                      }
                    </Button>
                    <Typography style={{margin: "0px 0px 40px"}}>
                      * Please wait for a notification in the top right corner of the page after pressing the Process Catalog button.
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: "left", margin: "10px auto", padding: "0px 20px"}}>
                    <Typography variant="h4" className="admin__product-settings" style={{textAlign: "left"}}>
                      QConnect Instructions
                    </Typography>
                    <Typography style={{margin: "10px 0px"}}>
                      Please ensure the following steps are completed during the initial setup of QConnect.
                    </Typography>
                    <List>
                      <ListItem >
                        <ListItemText>1. Go to the QConnect settings and enter in your QConnect username and password.</ListItemText>
                      </ListItem>
                      <ListItem >
                        <ListItemText>2. Click on the "Send Showroom Pricing CSV" checkbox.</ListItemText>
                      </ListItem>
                      <ListItem >
                        <ListItemText>3. Tag the products in the QFloors product catalog you would like to transfer to Showroom Pricing. <b>Please note: The limit is 25,000 and it is best to only transfer non-B2B vendors through QConnect.</b></ListItemText>
                      </ListItem>
                      <ListItem >
                        <ListItemText>4. Each product has to have an SKU number in QFloors.</ListItemText>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                  >
                    <Typography variant="h5">QConnect Settings</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Here you can change your QConnect credentials and automatically import your catalog from Qfloors. QConnect Imports will be shown in the Manual Files section of the home page.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Paper>
            </Grid>
          ) : undefined
        }

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item">
          <Paper elevation={5}>
            <Typography variant="h4" className="header-text">
              Product Page Settings
            </Typography>
            <Grid container spacing={2} style={{margin: "15px 10px"}}>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={prodReqLoginSwitchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleProdReqLoginChange(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="require login for pricing" style={prodReqLoginSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="dont require login for pricing" style={!prodReqLoginSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Require Login for Pricing?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={switchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleManufacturerToggle(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="show manufacturer" style={switchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="hide manufacturer" style={!switchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Show Manufacturer?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={roomCalcSwitchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleRoomCalcChange(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="show room calc" style={roomCalcSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="hide room calc" style={!roomCalcSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Show Room Calculator?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={locationSwitchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleLocationChange(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="show location" style={locationSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="hide location" style={!locationSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Show Location?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={prodCheckoutSwitchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleProdCheckoutChange(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="allow checkouts" style={prodCheckoutSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="no checkouts" style={!prodCheckoutSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Allow Sample Checkouts?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ToggleButtonGroup
                  value={prodFavSwitchState ? 'on' : 'off'}
                  exclusive
                  size='small'
                  onChange={(e, newValue) => handleProdFavChange(newValue)}
                  aria-label="text alignment"
                  style={{display: "inline-block"}}
                >
                  <ToggleButton value='on' aria-label="allow favorites list" style={prodFavSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='off' aria-label="no favorites list" style={!prodFavSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
                <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                  Allow Favorites List?
                </Typography>
              </Grid>

              { (
                  <>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodSpecsSwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdSpecsChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="show collection" style={prodSpecsSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="hide collection" style={!prodSpecsSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Show Product Specs?
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodCollectionSwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdCollectionChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="show collection" style={prodCollectionSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="hide collection" style={!prodCollectionSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Show Collection?
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodRelatedSwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdRelatedChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="show related products" style={prodRelatedSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="hide related products" style={!prodRelatedSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Show Related Products?
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodDiscoverySwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdDiscoveryChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="show product discovery" style={prodDiscoverySwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="hide product discovery" style={!prodDiscoverySwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Show Product Discovery? (Other Products You Might Like)
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodReqSelSwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdReqSelChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="require initial option selection" style={prodReqSelSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="dont require initial option selection" style={!prodReqSelSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Require Initial Option Selection?
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        value={prodCombineStyleSizesSwitchState ? 'on' : 'off'}
                        exclusive
                        size='small'
                        onChange={(e, newValue) => handleProdCombineStyleSizesChange(newValue)}
                        aria-label="text alignment"
                        style={{display: "inline-block"}}
                      >
                        <ToggleButton value='on' aria-label="show style sizes on one page" style={prodCombineStyleSizesSwitchState ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          Yes
                        </ToggleButton>
                        <ToggleButton value='off' aria-label="dont show style sizes on one page" style={!prodCombineStyleSizesSwitchState ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                          No
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                        Show All Style Sizes On One Page?
                      </Typography>
                    </Grid>
                  </>
                )
              }
            </Grid>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Product Page Settings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List dense>
                  <ListItem>
                    <ListItemText
                      primary="Manufacturer"
                      secondary="Selector to show manufacturer on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Room Calculator"
                      secondary="Selector to show room size calculator on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Location"
                      secondary="Selector to show location on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Sample Checkouts"
                      secondary="Selector to show product checkout on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Favorites List"
                      secondary="Selector to show product favorite on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Product Specs"
                      secondary="Selector to show product specs on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Collection"
                      secondary="Selector to show product collection on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Require Initial Option Selection"
                      secondary="Selector to require user to select an option to see pricing on product page."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Combine Like Sizes"
                      secondary="Selector to determine if all sizes for a style should show on one product page."
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item">
          <Paper elevation={5} style={{ textAlign: 'center' }}>
            <Typography variant="h4" className="header-text">
              Import Settings
            </Typography>
            <Typography variant="h4" className="admin__product-settings">
              Material Class/UOM
            </Typography>
            <Button
              variant="contained"
              onClick={handleMaterialClassOpen}
              style={{ display: 'inline-block', margin: '30px 20px 0px' }}
            >
              View/Edit Material Classes
            </Button>
            <Button
              variant="contained"
              onClick={handleUomOpen}
              style={{ display: 'inline-block', margin: '30px 20px 0px' }}
            >
              View/Edit UOM
            </Button>
            <Accordion style={{ marginTop: '40px' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Import Settings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Here you can add new material classes, material class codes,
                  and UOM types.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item" style={{ display: 'flex' }}>
          <Paper elevation={5} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {renderUploadLogo()}
            <Accordion style={{ marginTop: 'auto' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Company Logo Upload</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Use this to upload your company logo or an image of your
                  choice. (PNG files only)
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item" style={{ display: 'flex' }}>
          <Paper elevation={5} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {renderLogoLink()}
            <Accordion style={{ marginTop: 'auto' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Logo Link</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Here you can set your company logo as a link to wherever you
                  like.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        <BarcodeSettings />

        <Grid item xs={12} sm={12} md={6} lg={6} className="admin__grid-item" style={{ display: 'flex' }} id="tour-timezone-setting">
          <Paper elevation={5} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" className="header-text">
              Default Timezone
            </Typography>
            <div style={{ padding: '16px 24px' }}>
              <Typography variant="body1" style={{ marginBottom: 16 }}>
                Timestamps across the app are shown in this timezone for everyone
                who has not chosen their own. Each user can override it on their
                profile page.
              </Typography>
              <TimezonePicker
                value={instanceTimezone}
                onChange={setInstanceTimezone}
                label="Company default timezone"
              />
              <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Button
                  variant="contained"
                  onClick={handleInstanceTimezoneSave}
                  disabled={savingInstanceTz || !instanceTimezone || instanceTimezone === defaultZone}
                >
                  {savingInstanceTz ? 'Saving…' : 'Save Default'}
                </Button>
              </div>
            </div>
            <Accordion style={{ marginTop: 'auto' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="timezone-content"
              >
                <Typography variant="h5">About Timezones</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Existing timestamps were recorded in Central time and are
                  reinterpreted into the selected timezone for display — the
                  stored data is never changed, so historical dates stay
                  accurate. Changing this only affects how times are shown.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

      </Grid>
      {renderDialog()}
    </div>
  );
};

export default LogoLinkUpdate;
